import { IModel } from "@/@types/models/model";
import { coreFields } from "@/models/helpers/coreFields";

const SigurnosnePoruke: IModel = {
  title: "Sigurnosne Poruke",
  apiPath: "sigurnosne-poruke",
  httpUpdateVerb: "put",
  forms: {
    "default": {
      fields: ["id", "code", "opis_servisni", "opis_hr", "opis_en"]
    },
  },
  listViews: {
    "default": {
      fields: ["id", "code", "ttoken", "opis_servisni", "opis_hr", "opis_en"],
      hidden: ["id", "ttoken"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "code",
      source: "code",
      ttoken: "sigurnosne_poruke.code",
      type: "numeric",
      filter: true,
      validation: {
        required: true
      },
    },
    {
      title: "ttoken",
      source: "ttoken",
      ttoken: "sigurnosne_poruke.ttoken",
      type: "text",
      filter: true,
      validation: {
        required: true
      },
    },
    {
      title: "opis_servisni",
      source: "opis_servisni",
      ttoken: "sigurnosne_poruke.opis_servisni",
      type: "text",
      filter: true,
      validation: {
        required: true
      },
    },
    {
      title: "opis_hr",
      source: "opis_hr",
      ttoken: "sigurnosne_poruke.opis_hr",
      type: "text",
      filter: true,
      validation: {
        required: true
      },
    },
      {
        title: "opis_en",
        source: "opis_en",
        ttoken: "sigurnosne_poruke.opis_en",
        type: "text",
        filter: true,
        validation: {
          required: true
        },
    }
  ]
}

export default SigurnosnePoruke;
